export default [
  {
    path: '/',
    text: 'New Campaign',
  },
  {
    path: '/manage-campaigns',
    text: 'Manage Campaigns',
  },
];



// WEBPACK FOOTER //
// ./src/baseNavItems.js